import { useState } from 'react';
import CardUpdatePinForm from '../card-update-pin-form/card-update-pin-form';
import './card-update-pin-form-confirmation.scss';
import { useSelector, useDispatch } from 'react-redux';
import { cardsUpdatePinRequest } from 'actions/cardActions';
import { trackCustomEvent } from 'utilities/app-insights';
import {
  ButtonColor,
  useModal,
} from '@ampol/design-system';
import SmallPanel, {
  PanelButton,
} from 'features/cards/modals/card-detail-modal/SmallPanel';

interface CardUpdatePinFormConfirmationProps {
  confirmationMessage: string;
  closeForm: () => void;
  cardNumbers: string[];
  disabled?: boolean;
  headless?: boolean;
}

// Not sure why eslint thinks this is unused, but it is. Had to disable the rule.
// eslint-disable-next-line no-unused-vars
enum ButtonState {
  // eslint-disable-next-line no-unused-vars
  Submit = 'submit',
  // eslint-disable-next-line no-unused-vars
  Confirm = 'confirm',
}

interface ConfirmUpdatePinModalProps {
  onConfirm: () => void;
  message: string;
}

const useConfirmUpdatePinModal = (props: ConfirmUpdatePinModalProps) => {
  const modal = useModal({
    color: ButtonColor.Blue,
    title: 'Are you sure?',
    id: 'update-pin-modal',
    variant: 'double',
    content: <p>{props.message}</p>,
    actions: [
      {
        label: 'Confirm',
        onClick: () => {
          props.onConfirm();
          modal.close();
        },
      },
      {
        label: 'Cancel',
        onClick: () => modal.close(),
      },
    ],
  });

  return modal;
};

const CardUpdatePinFormConfirmation = ({
  confirmationMessage,
  closeForm,
  cardNumbers,
  disabled,
  headless,
}: CardUpdatePinFormConfirmationProps) => {
  const dispatch = useDispatch();

  const readOnly = !useSelector(
    (state: any) => state.userStore.canReadWriteCards
  );
  const loggedInUser = useSelector(
    (state: any) => state.userStore.loggedInUser
  );
  const assignedGrandfatherClientNumber = useSelector(
    (state: any) => state.userStore.assignedGrandfatherClientNumber
  );
  const assignedAccountNumber = useSelector(
    (state: any) => state.userStore.assignedAccountNumber
  );

  const confirmClickCallback = () => {
    window.dataLayer.push({
      event: 'Card_Portal_Individual_Card_Detail_New_PIN',
      pin_entered: true,
    });

    dispatch(
      cardsUpdatePinRequest(
        cardNumbers,
        newPin,
        loggedInUser.userId,
        assignedGrandfatherClientNumber
      )
    );

    trackCustomEvent(
      'Submit Update Pin',
      loggedInUser,
      assignedAccountNumber,
      'Clicked Submit button to submit Update Pin.',
      { selectedCard: cardNumbers }
    );

    closeForm();
  };

  const confirmUpdatePinModal = useConfirmUpdatePinModal({
    onConfirm: confirmClickCallback,
    message: confirmationMessage,
  });
  const [newPin, setNewPin] = useState('');


  const submitCallback = ({ newPin }) => {
    if (readOnly) {
      return;
    }

    setNewPin(newPin);
    confirmUpdatePinModal.open();
  };

  const formId = 'update-pin';
  const submitButton: PanelButton = {
    label: 'Submit',
    formId,
  };

  return (
    <SmallPanel
      title="Update PIN"
      disabled={disabled}
      buttons={[submitButton]}
      headless={headless}
    >
      <CardUpdatePinForm
        onValidation={() => {}}
        readOnly={readOnly}
        formId={formId}
        onSubmit={submitCallback}
      />
    </SmallPanel>
  );
};

export default CardUpdatePinFormConfirmation;
